export const NO_RECORD_ERROR = 'NO_RECORD';
export const SAML_ERROR = 'SAML_ERROR';